import { Top } from '../entities/Top';
import { Rack } from '../entities/Rack';
import { Cabinet } from '../entities/Cabinet';
import { Position } from '../constants';
import { Shelf } from '../entities/Shelf';

function checkAndUpdatePlatesType(
  rackOrTop: Rack,
  shelf: Shelf | undefined,
  update: boolean,
) {
  const acceptedTypes = Rack.acceptedPlatesTypes(
    rackOrTop.getCrossPiece(Position.Front)?.base.type,
    rackOrTop.getCrossPiece(Position.Back)?.base.type,
  );

  const currentPlateType = rackOrTop.plate?.plateType;
  if (!currentPlateType) return;
  if (!acceptedTypes.includes(currentPlateType)) {
    if (!update) {
      console.debug(
        '[Plates Manager] ERROR type',
        rackOrTop instanceof Top ? 'Top' : `Shelf ${shelf?.level}`,
        currentPlateType,
        acceptedTypes,
      );
      throw new Error(
        `${
          rackOrTop instanceof Top ? 'Top' : `Shelf ${shelf?.level}`
        } has bad plate type for plate ${currentPlateType}`,
      );
    }

    rackOrTop.updatePlate(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      Rack.getDefaultPlateType(acceptedTypes),
    );

    console.debug(
      '[Plates Manager] auto update plate depth type',
      rackOrTop instanceof Top ? 'Top' : `Shelf ${shelf?.level}`,
      currentPlateType,
      Rack.getDefaultPlateType(acceptedTypes),
    );
  }
}

function checkAndUpdateWheelpaneType(
  rack: Rack,
  cabinet: Cabinet,
  update: boolean,
) {
  const acceptedTypes = Rack.acceptedPlatesTypes(
    rack.getCrossPiece(Position.Front)?.base.type,
    rack.getCrossPiece(Position.Back)?.base.type,
  );

  const currentWheelPaneType = cabinet.wheelPane?.base.drilling;
  if (!currentWheelPaneType) return;
  if (!acceptedTypes.includes(currentWheelPaneType)) {
    if (!update) {
      console.debug(
        '[Wheel Pane Manager] ERROR type',
        currentWheelPaneType,
        acceptedTypes,
      );
      throw new Error(
        `Cabinet has bad wheel pane type for wheel pane ${currentWheelPaneType}`,
      );
    }

    cabinet.addOrUpdateWheelSupportPane(
      undefined,
      undefined,
      undefined,
      Rack.getDefaultPlateType(acceptedTypes),
    );

    console.debug(
      '[Wheel Pane Manager] ERROR type',
      currentWheelPaneType,
      Rack.getDefaultPlateType(acceptedTypes),
    );
  }
}

export function checkAndUpdateWheelPane(cabinet: Cabinet, update = true): void {
  checkAndUpdateWheelpaneType(cabinet.shelf(0).rack(0), cabinet, update);
}

export function checkAndUpdatePlates(cabinet: Cabinet, update = true): void {
  checkAndUpdatePlatesType(cabinet.top, undefined, update);
  for (const shelf of cabinet.shelves)
    checkAndUpdatePlatesType(shelf.rack(0), shelf, update);
}
